@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-58_336_556)
public val Res.string.occasion_label: StringResource by lazy {
      StringResource("string:occasion_label", "occasion_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192658, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272610, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175601, 34),
      ))
    }

@delegate:ResourceContentHash(622_591_479)
public val Res.string.occasion_own_wedding: StringResource by lazy {
      StringResource("string:occasion_own_wedding", "occasion_own_wedding", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192701, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272649, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175636, 56),
      ))
    }

@delegate:ResourceContentHash(-1_552_655_250)
public val Res.string.occasion_proof: StringResource by lazy {
      StringResource("string:occasion_proof", "occasion_proof", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192762, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272730, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175693, 102),
      ))
    }

@delegate:ResourceContentHash(-343_446_993)
public val Res.string.ohs_admitted_on: StringResource by lazy {
      StringResource("string:ohs_admitted_on", "ohs_admitted_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 192921, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 272929, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175796, 87),
      ))
    }

@delegate:ResourceContentHash(379_905_356)
public val Res.string.ohs_card_pdf: StringResource by lazy {
      StringResource("string:ohs_card_pdf", "ohs_card_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193017, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273093, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175884, 56),
      ))
    }

@delegate:ResourceContentHash(285_785_624)
public val Res.string.ohs_certificate_number: StringResource by lazy {
      StringResource("string:ohs_certificate_number", "ohs_certificate_number", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193214, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273370, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176065, 54),
      ))
    }

@delegate:ResourceContentHash(-100_816_693)
public val Res.string.ohs_certificate_number_hint: StringResource by lazy {
      StringResource("string:ohs_certificate_number_hint", "ohs_certificate_number_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193082, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273186, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175941, 123),
      ))
    }

@delegate:ResourceContentHash(-261_275_775)
public val Res.string.ohs_certificate_pdf: StringResource by lazy {
      StringResource("string:ohs_certificate_pdf", "ohs_certificate_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193273, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273441, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176120, 79),
      ))
    }

@delegate:ResourceContentHash(1_142_993_522)
public val Res.string.ohs_change: StringResource by lazy {
      StringResource("string:ohs_change", "ohs_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193357, 26),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273561, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176200, 26),
      ))
    }

@delegate:ResourceContentHash(-1_425_767_523)
public val Res.string.ohs_commission: StringResource by lazy {
      StringResource("string:ohs_commission", "ohs_commission", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193384, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273600, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176227, 46),
      ))
    }

@delegate:ResourceContentHash(962_663_615)
public val Res.string.ohs_completed_on: StringResource by lazy {
      StringResource("string:ohs_completed_on", "ohs_completed_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193427, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273659, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176274, 48),
      ))
    }

@delegate:ResourceContentHash(-1_295_340_820)
public val Res.string.ohs_conducted_by: StringResource by lazy {
      StringResource("string:ohs_conducted_by", "ohs_conducted_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193476, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273724, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176323, 52),
      ))
    }

@delegate:ResourceContentHash(1_466_215_577)
public val Res.string.ohs_conducted_on: StringResource by lazy {
      StringResource("string:ohs_conducted_on", "ohs_conducted_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193541, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273793, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176376, 60),
      ))
    }

@delegate:ResourceContentHash(168_122_983)
public val Res.string.ohs_confirm: StringResource by lazy {
      StringResource("string:ohs_confirm", "ohs_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194335, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274867, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177074, 31),
      ))
    }

@delegate:ResourceContentHash(-945_226_346)
public val Res.string.ohs_confirm_general_statement: StringResource by lazy {
      StringResource("string:ohs_confirm_general_statement", "ohs_confirm_general_statement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193610, 245),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 273886, 369),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176437, 213),
      ))
    }

@delegate:ResourceContentHash(1_281_545_330)
public val Res.string.ohs_confirm_station_statement: StringResource by lazy {
      StringResource("string:ohs_confirm_station_statement", "ohs_confirm_station_statement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 193856, 289),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274256, 357),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176651, 245),
      ))
    }

@delegate:ResourceContentHash(2_140_820_620)
public val Res.string.ohs_confirm_title: StringResource by lazy {
      StringResource("string:ohs_confirm_title", "ohs_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194146, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274614, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176897, 57),
      ))
    }

@delegate:ResourceContentHash(1_190_160_649)
public val Res.string.ohs_confirmed: StringResource by lazy {
      StringResource("string:ohs_confirmed", "ohs_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194281, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274785, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177024, 49),
      ))
    }

@delegate:ResourceContentHash(1_171_749_735)
public val Res.string.ohs_confirmed_on: StringResource by lazy {
      StringResource("string:ohs_confirmed_on", "ohs_confirmed_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194208, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274700, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176955, 68),
      ))
    }

@delegate:ResourceContentHash(167_523_096)
public val Res.string.ohs_dates_done: StringResource by lazy {
      StringResource("string:ohs_dates_done", "ohs_dates_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194371, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 274919, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177106, 86),
      ))
    }

@delegate:ResourceContentHash(-532_036_896)
public val Res.string.ohs_dates_missing: StringResource by lazy {
      StringResource("string:ohs_dates_missing", "ohs_dates_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194462, 137),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275066, 237),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177193, 97),
      ))
    }

@delegate:ResourceContentHash(414_913_314)
public val Res.string.ohs_documents: StringResource by lazy {
      StringResource("string:ohs_documents", "ohs_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194600, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275304, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177291, 33),
      ))
    }

@delegate:ResourceContentHash(402_843_566)
public val Res.string.ohs_exam_on: StringResource by lazy {
      StringResource("string:ohs_exam_on", "ohs_exam_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194634, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275350, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177325, 51),
      ))
    }

@delegate:ResourceContentHash(519_382_495)
public val Res.string.ohs_field_admitted_by: StringResource by lazy {
      StringResource("string:ohs_field_admitted_by", "ohs_field_admitted_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194690, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275426, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177377, 45),
      ))
    }

@delegate:ResourceContentHash(-955_778_349)
public val Res.string.ohs_field_admitted_on: StringResource by lazy {
      StringResource("string:ohs_field_admitted_on", "ohs_field_admitted_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194748, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275488, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177423, 57),
      ))
    }

@delegate:ResourceContentHash(-1_180_988_522)
public val Res.string.ohs_field_certificate: StringResource by lazy {
      StringResource("string:ohs_field_certificate", "ohs_field_certificate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194806, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275558, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177481, 45),
      ))
    }

@delegate:ResourceContentHash(-797_788_215)
public val Res.string.ohs_field_conducted_by: StringResource by lazy {
      StringResource("string:ohs_field_conducted_by", "ohs_field_conducted_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194856, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275620, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177527, 46),
      ))
    }

@delegate:ResourceContentHash(739_076_618)
public val Res.string.ohs_field_conducted_on: StringResource by lazy {
      StringResource("string:ohs_field_conducted_on", "ohs_field_conducted_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194903, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275683, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177574, 46),
      ))
    }

@delegate:ResourceContentHash(-1_294_893_290)
public val Res.string.ohs_field_confirmation: StringResource by lazy {
      StringResource("string:ohs_field_confirmation", "ohs_field_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 194958, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275758, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177621, 62),
      ))
    }

@delegate:ResourceContentHash(879_716_839)
public val Res.string.ohs_field_date: StringResource by lazy {
      StringResource("string:ohs_field_date", "ohs_field_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195021, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275853, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177684, 30),
      ))
    }

@delegate:ResourceContentHash(487_102_862)
public val Res.string.ohs_field_exam_on: StringResource by lazy {
      StringResource("string:ohs_field_exam_on", "ohs_field_exam_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195052, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275888, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177715, 37),
      ))
    }

@delegate:ResourceContentHash(-1_261_382_207)
public val Res.string.ohs_field_form: StringResource by lazy {
      StringResource("string:ohs_field_form", "ohs_field_form", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195098, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275942, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177753, 30),
      ))
    }

@delegate:ResourceContentHash(-968_702_679)
public val Res.string.ohs_general: StringResource by lazy {
      StringResource("string:ohs_general", "ohs_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195498, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276534, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178097, 47),
      ))
    }

@delegate:ResourceContentHash(918_611_519)
public val Res.string.ohs_general_in_person: StringResource by lazy {
      StringResource("string:ohs_general_in_person", "ohs_general_in_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195129, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 275981, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177784, 49),
      ))
    }

@delegate:ResourceContentHash(-388_086_659)
public val Res.string.ohs_general_missing: StringResource by lazy {
      StringResource("string:ohs_general_missing", "ohs_general_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195195, 183),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276059, 311),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177834, 163),
      ))
    }

@delegate:ResourceContentHash(-77_426_946)
public val Res.string.ohs_general_online: StringResource by lazy {
      StringResource("string:ohs_general_online", "ohs_general_online", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195379, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276371, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 177998, 98),
      ))
    }

@delegate:ResourceContentHash(474_046_421)
public val Res.string.ohs_group: StringResource by lazy {
      StringResource("string:ohs_group", "ohs_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195928, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 277140, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178491, 25),
      ))
    }

@delegate:ResourceContentHash(-1_384_685_344)
public val Res.string.ohs_group_admin_office: StringResource by lazy {
      StringResource("string:ohs_group_admin_office", "ohs_group_admin_office", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195546, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276606, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178145, 78),
      ))
    }

@delegate:ResourceContentHash(760_876_499)
public val Res.string.ohs_group_blue_collar: StringResource by lazy {
      StringResource("string:ohs_group_blue_collar", "ohs_group_blue_collar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195625, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276713, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178224, 57),
      ))
    }

@delegate:ResourceContentHash(-600_661_060)
public val Res.string.ohs_group_managers: StringResource by lazy {
      StringResource("string:ohs_group_managers", "ohs_group_managers", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195683, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276787, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178282, 70),
      ))
    }

@delegate:ResourceContentHash(744_850_968)
public val Res.string.ohs_group_other: StringResource by lazy {
      StringResource("string:ohs_group_other", "ohs_group_other", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195770, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 276926, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178353, 67),
      ))
    }

@delegate:ResourceContentHash(-369_344_309)
public val Res.string.ohs_group_unknown: StringResource by lazy {
      StringResource("string:ohs_group_unknown", "ohs_group_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195838, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 277018, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178421, 69),
      ))
    }

@delegate:ResourceContentHash(2_083_471_487)
public val Res.string.ohs_initial: StringResource by lazy {
      StringResource("string:ohs_initial", "ohs_initial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195954, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 277174, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178517, 43),
      ))
    }

@delegate:ResourceContentHash(-329_847_322)
public val Res.string.ohs_intro: StringResource by lazy {
      StringResource("string:ohs_intro", "ohs_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 195998, 473),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 277238, 885),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178561, 413),
      ))
    }

@delegate:ResourceContentHash(1_239_014_746)
public val Res.string.ohs_my_record: StringResource by lazy {
      StringResource("string:ohs_my_record", "ohs_my_record", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 196472, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 278124, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178975, 45),
      ))
    }

@delegate:ResourceContentHash(1_783_459_876)
public val Res.string.ohs_not_signature: StringResource by lazy {
      StringResource("string:ohs_not_signature", "ohs_not_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 196522, 317),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 278218, 649),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179021, 353),
      ))
    }

@delegate:ResourceContentHash(-1_757_029_386)
public val Res.string.ohs_open_record: StringResource by lazy {
      StringResource("string:ohs_open_record", "ohs_open_record", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 196840, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 278868, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179375, 51),
      ))
    }

@delegate:ResourceContentHash(-1_058_505_360)
public val Res.string.ohs_organizer: StringResource by lazy {
      StringResource("string:ohs_organizer", "ohs_organizer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 196896, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 278968, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179427, 57),
      ))
    }

@delegate:ResourceContentHash(402_368_515)
public val Res.string.ohs_owner_text: StringResource by lazy {
      StringResource("string:ohs_owner_text", "ohs_owner_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 196946, 370),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 279042, 654),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179485, 342),
      ))
    }

@delegate:ResourceContentHash(-1_253_940_981)
public val Res.string.ohs_owner_title: StringResource by lazy {
      StringResource("string:ohs_owner_title", "ohs_owner_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197317, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 279697, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179828, 83),
      ))
    }

@delegate:ResourceContentHash(936_032_727)
public val Res.string.ohs_periodic: StringResource by lazy {
      StringResource("string:ohs_periodic", "ohs_periodic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197726, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280322, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180217, 44),
      ))
    }

@delegate:ResourceContentHash(-2_031_771_131)
public val Res.string.ohs_periodic_elsewhere: StringResource by lazy {
      StringResource("string:ohs_periodic_elsewhere", "ohs_periodic_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197401, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 279821, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179912, 70),
      ))
    }

@delegate:ResourceContentHash(-455_192_702)
public val Res.string.ohs_periodic_missing: StringResource by lazy {
      StringResource("string:ohs_periodic_missing", "ohs_periodic_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197484, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 279940, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179983, 68),
      ))
    }

@delegate:ResourceContentHash(-1_033_369_963)
public val Res.string.ohs_periodic_test_passed: StringResource by lazy {
      StringResource("string:ohs_periodic_test_passed", "ohs_periodic_test_passed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197561, 164),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280049, 272),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180052, 164),
      ))
    }

@delegate:ResourceContentHash(717_074_590)
public val Res.string.ohs_position: StringResource by lazy {
      StringResource("string:ohs_position", "ohs_position", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197771, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280395, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180262, 32),
      ))
    }

@delegate:ResourceContentHash(-602_525_549)
public val Res.string.ohs_record_complete: StringResource by lazy {
      StringResource("string:ohs_record_complete", "ohs_record_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197808, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280432, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180295, 67),
      ))
    }

@delegate:ResourceContentHash(1_688_653_117)
public val Res.string.ohs_record_exam: StringResource by lazy {
      StringResource("string:ohs_record_exam", "ohs_record_exam", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197884, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280568, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180363, 43),
      ))
    }

@delegate:ResourceContentHash(-693_795_307)
public val Res.string.ohs_record_general: StringResource by lazy {
      StringResource("string:ohs_record_general", "ohs_record_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 197928, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280628, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180407, 86),
      ))
    }

@delegate:ResourceContentHash(-2_096_309_536)
public val Res.string.ohs_record_incomplete: StringResource by lazy {
      StringResource("string:ohs_record_incomplete", "ohs_record_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198027, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280783, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180494, 81),
      ))
    }

@delegate:ResourceContentHash(-1_592_595_476)
public val Res.string.ohs_record_station: StringResource by lazy {
      StringResource("string:ohs_record_station", "ohs_record_station", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198125, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 280933, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180576, 70),
      ))
    }

@delegate:ResourceContentHash(1_806_407_298)
public val Res.string.ohs_record_title: StringResource by lazy {
      StringResource("string:ohs_record_title", "ohs_record_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198252, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281152, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180699, 44),
      ))
    }

@delegate:ResourceContentHash(-104_265_405)
public val Res.string.ohs_record_title_of: StringResource by lazy {
      StringResource("string:ohs_record_title_of", "ohs_record_title_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198196, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281056, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180647, 51),
      ))
    }

@delegate:ResourceContentHash(-29_980_349)
public val Res.string.ohs_recorded: StringResource by lazy {
      StringResource("string:ohs_recorded", "ohs_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198301, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281249, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180744, 32),
      ))
    }

@delegate:ResourceContentHash(-46_867_413)
public val Res.string.ohs_save: StringResource by lazy {
      StringResource("string:ohs_save", "ohs_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198334, 24),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281294, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180777, 24),
      ))
    }

@delegate:ResourceContentHash(-63_687_404)
public val Res.string.ohs_settings: StringResource by lazy {
      StringResource("string:ohs_settings", "ohs_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198359, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281335, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180802, 40),
      ))
    }

@delegate:ResourceContentHash(1_241_002_846)
public val Res.string.ohs_station: StringResource by lazy {
      StringResource("string:ohs_station", "ohs_station", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198976, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282220, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181363, 47),
      ))
    }

@delegate:ResourceContentHash(-1_735_782_792)
public val Res.string.ohs_station_missing: StringResource by lazy {
      StringResource("string:ohs_station_missing", "ohs_station_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198400, 191),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281384, 271),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180843, 175),
      ))
    }

@delegate:ResourceContentHash(2_098_983_946)
public val Res.string.ohs_station_not_required: StringResource by lazy {
      StringResource("string:ohs_station_not_required", "ohs_station_not_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198592, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281656, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181019, 104),
      ))
    }

@delegate:ResourceContentHash(-1_727_189_833)
public val Res.string.ohs_station_required: StringResource by lazy {
      StringResource("string:ohs_station_required", "ohs_station_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198903, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282095, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181294, 68),
      ))
    }

@delegate:ResourceContentHash(-590_229_174)
public val Res.string.ohs_station_required_hint: StringResource by lazy {
      StringResource("string:ohs_station_required_hint", "ohs_station_required_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 198705, 197),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 281829, 265),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181124, 169),
      ))
    }

@delegate:ResourceContentHash(1_105_780_940)
public val Res.string.ohs_status_done: StringResource by lazy {
      StringResource("string:ohs_status_done", "ohs_status_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199028, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282312, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181411, 31),
      ))
    }

@delegate:ResourceContentHash(-2_043_560_609)
public val Res.string.ohs_status_missing: StringResource by lazy {
      StringResource("string:ohs_status_missing", "ohs_status_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199068, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282360, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181443, 42),
      ))
    }

@delegate:ResourceContentHash(-1_526_325_809)
public val Res.string.ohs_status_not_required: StringResource by lazy {
      StringResource("string:ohs_status_not_required", "ohs_status_not_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199111, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282415, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181486, 47),
      ))
    }

@delegate:ResourceContentHash(-1_714_661_126)
public val Res.string.ohs_status_to_confirm: StringResource by lazy {
      StringResource("string:ohs_status_to_confirm", "ohs_status_to_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199159, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282475, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181534, 45),
      ))
    }

@delegate:ResourceContentHash(-1_539_056_103)
public val Res.string.ohs_to_confirm_general: StringResource by lazy {
      StringResource("string:ohs_to_confirm_general", "ohs_to_confirm_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199213, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282557, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181580, 78),
      ))
    }

@delegate:ResourceContentHash(1_289_397_915)
public val Res.string.ohs_to_confirm_station: StringResource by lazy {
      StringResource("string:ohs_to_confirm_station", "ohs_to_confirm_station", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199304, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282704, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181659, 78),
      ))
    }

@delegate:ResourceContentHash(-1_856_453_351)
public val Res.string.ohs_waiting_confirmation: StringResource by lazy {
      StringResource("string:ohs_waiting_confirmation", "ohs_waiting_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199399, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282831, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181738, 84),
      ))
    }

@delegate:ResourceContentHash(-1_760_634_682)
public val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199476, 14),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282944, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181823, 14),
      ))
    }

@delegate:ResourceContentHash(-1_218_834_352)
public val Res.string.onboarding_business_desc: StringResource by lazy {
      StringResource("string:onboarding_business_desc", "onboarding_business_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199491, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 282959, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181838, 136),
      ))
    }

@delegate:ResourceContentHash(-80_840_211)
public val Res.string.onboarding_business_title: StringResource by lazy {
      StringResource("string:onboarding_business_title", "onboarding_business_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199628, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283180, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 181975, 73),
      ))
    }

@delegate:ResourceContentHash(895_303_280)
public val Res.string.onboarding_day_template: StringResource by lazy {
      StringResource("string:onboarding_day_template", "onboarding_day_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199702, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283286, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182049, 47),
      ))
    }

@delegate:ResourceContentHash(1_153_611_977)
public val Res.string.onboarding_done_generic: StringResource by lazy {
      StringResource("string:onboarding_done_generic", "onboarding_done_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199754, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283354, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182097, 63),
      ))
    }

@delegate:ResourceContentHash(-406_107_138)
public val Res.string.onboarding_done_join: StringResource by lazy {
      StringResource("string:onboarding_done_join", "onboarding_done_join", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199818, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283458, 220),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182161, 132),
      ))
    }

@delegate:ResourceContentHash(-565_736_675)
public val Res.string.onboarding_done_owner: StringResource by lazy {
      StringResource("string:onboarding_done_owner", "onboarding_done_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 199959, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283679, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182294, 117),
      ))
    }

@delegate:ResourceContentHash(-505_210_624)
public val Res.string.onboarding_done_permissions: StringResource by lazy {
      StringResource("string:onboarding_done_permissions", "onboarding_done_permissions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200089, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283865, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182412, 67),
      ))
    }

@delegate:ResourceContentHash(1_030_066_113)
public val Res.string.onboarding_done_title: StringResource by lazy {
      StringResource("string:onboarding_done_title", "onboarding_done_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200153, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 283957, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182480, 53),
      ))
    }

@delegate:ResourceContentHash(1_680_974_279)
public val Res.string.onboarding_error_empty_code: StringResource by lazy {
      StringResource("string:onboarding_error_empty_code", "onboarding_error_empty_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200207, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284015, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182534, 63),
      ))
    }

@delegate:ResourceContentHash(1_342_163_801)
public val Res.string.onboarding_finance_desc: StringResource by lazy {
      StringResource("string:onboarding_finance_desc", "onboarding_finance_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200275, 239),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284115, 379),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182598, 211),
      ))
    }

@delegate:ResourceContentHash(-2_121_245_318)
public val Res.string.onboarding_finance_no: StringResource by lazy {
      StringResource("string:onboarding_finance_no", "onboarding_finance_no", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200626, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284678, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182921, 57),
      ))
    }

@delegate:ResourceContentHash(-1_713_118_070)
public val Res.string.onboarding_finance_no_desc: StringResource by lazy {
      StringResource("string:onboarding_finance_no_desc", "onboarding_finance_no_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200515, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284495, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182810, 110),
      ))
    }

@delegate:ResourceContentHash(1_619_898_006)
public val Res.string.onboarding_finance_title: StringResource by lazy {
      StringResource("string:onboarding_finance_title", "onboarding_finance_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200680, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284744, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 182979, 88),
      ))
    }

@delegate:ResourceContentHash(1_147_876_983)
public val Res.string.onboarding_finance_yes: StringResource by lazy {
      StringResource("string:onboarding_finance_yes", "onboarding_finance_yes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200889, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285041, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183168, 62),
      ))
    }

@delegate:ResourceContentHash(1_831_401_445)
public val Res.string.onboarding_finance_yes_desc: StringResource by lazy {
      StringResource("string:onboarding_finance_yes_desc", "onboarding_finance_yes_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200789, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 284905, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183068, 99),
      ))
    }

@delegate:ResourceContentHash(-798_484_251)
public val Res.string.onboarding_finishing: StringResource by lazy {
      StringResource("string:onboarding_finishing", "onboarding_finishing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 200948, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285128, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183231, 60),
      ))
    }

@delegate:ResourceContentHash(1_077_395_540)
public val Res.string.onboarding_get_started: StringResource by lazy {
      StringResource("string:onboarding_get_started", "onboarding_get_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201013, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285221, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183292, 46),
      ))
    }

@delegate:ResourceContentHash(713_866_354)
public val Res.string.onboarding_go_to_dashboard: StringResource by lazy {
      StringResource("string:onboarding_go_to_dashboard", "onboarding_go_to_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201056, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285268, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183339, 62),
      ))
    }

@delegate:ResourceContentHash(694_916_470)
public val Res.string.onboarding_hours_closes: StringResource by lazy {
      StringResource("string:onboarding_hours_closes", "onboarding_hours_closes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201119, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285367, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183402, 39),
      ))
    }

@delegate:ResourceContentHash(468_518_022)
public val Res.string.onboarding_hours_days: StringResource by lazy {
      StringResource("string:onboarding_hours_days", "onboarding_hours_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201167, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285423, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183442, 41),
      ))
    }

@delegate:ResourceContentHash(-303_193_542)
public val Res.string.onboarding_hours_desc: StringResource by lazy {
      StringResource("string:onboarding_hours_desc", "onboarding_hours_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201213, 125),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285481, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183484, 129),
      ))
    }

@delegate:ResourceContentHash(578_959_337)
public val Res.string.onboarding_hours_earlier: StringResource by lazy {
      StringResource("string:onboarding_hours_earlier", "onboarding_hours_earlier", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 201339, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 285687, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183614, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString24Resources(map: MutableMap<String, StringResource>) {
  map.put("occasion_label", Res.string.occasion_label)
  map.put("occasion_own_wedding", Res.string.occasion_own_wedding)
  map.put("occasion_proof", Res.string.occasion_proof)
  map.put("ohs_admitted_on", Res.string.ohs_admitted_on)
  map.put("ohs_card_pdf", Res.string.ohs_card_pdf)
  map.put("ohs_certificate_number", Res.string.ohs_certificate_number)
  map.put("ohs_certificate_number_hint", Res.string.ohs_certificate_number_hint)
  map.put("ohs_certificate_pdf", Res.string.ohs_certificate_pdf)
  map.put("ohs_change", Res.string.ohs_change)
  map.put("ohs_commission", Res.string.ohs_commission)
  map.put("ohs_completed_on", Res.string.ohs_completed_on)
  map.put("ohs_conducted_by", Res.string.ohs_conducted_by)
  map.put("ohs_conducted_on", Res.string.ohs_conducted_on)
  map.put("ohs_confirm", Res.string.ohs_confirm)
  map.put("ohs_confirm_general_statement", Res.string.ohs_confirm_general_statement)
  map.put("ohs_confirm_station_statement", Res.string.ohs_confirm_station_statement)
  map.put("ohs_confirm_title", Res.string.ohs_confirm_title)
  map.put("ohs_confirmed", Res.string.ohs_confirmed)
  map.put("ohs_confirmed_on", Res.string.ohs_confirmed_on)
  map.put("ohs_dates_done", Res.string.ohs_dates_done)
  map.put("ohs_dates_missing", Res.string.ohs_dates_missing)
  map.put("ohs_documents", Res.string.ohs_documents)
  map.put("ohs_exam_on", Res.string.ohs_exam_on)
  map.put("ohs_field_admitted_by", Res.string.ohs_field_admitted_by)
  map.put("ohs_field_admitted_on", Res.string.ohs_field_admitted_on)
  map.put("ohs_field_certificate", Res.string.ohs_field_certificate)
  map.put("ohs_field_conducted_by", Res.string.ohs_field_conducted_by)
  map.put("ohs_field_conducted_on", Res.string.ohs_field_conducted_on)
  map.put("ohs_field_confirmation", Res.string.ohs_field_confirmation)
  map.put("ohs_field_date", Res.string.ohs_field_date)
  map.put("ohs_field_exam_on", Res.string.ohs_field_exam_on)
  map.put("ohs_field_form", Res.string.ohs_field_form)
  map.put("ohs_general", Res.string.ohs_general)
  map.put("ohs_general_in_person", Res.string.ohs_general_in_person)
  map.put("ohs_general_missing", Res.string.ohs_general_missing)
  map.put("ohs_general_online", Res.string.ohs_general_online)
  map.put("ohs_group", Res.string.ohs_group)
  map.put("ohs_group_admin_office", Res.string.ohs_group_admin_office)
  map.put("ohs_group_blue_collar", Res.string.ohs_group_blue_collar)
  map.put("ohs_group_managers", Res.string.ohs_group_managers)
  map.put("ohs_group_other", Res.string.ohs_group_other)
  map.put("ohs_group_unknown", Res.string.ohs_group_unknown)
  map.put("ohs_initial", Res.string.ohs_initial)
  map.put("ohs_intro", Res.string.ohs_intro)
  map.put("ohs_my_record", Res.string.ohs_my_record)
  map.put("ohs_not_signature", Res.string.ohs_not_signature)
  map.put("ohs_open_record", Res.string.ohs_open_record)
  map.put("ohs_organizer", Res.string.ohs_organizer)
  map.put("ohs_owner_text", Res.string.ohs_owner_text)
  map.put("ohs_owner_title", Res.string.ohs_owner_title)
  map.put("ohs_periodic", Res.string.ohs_periodic)
  map.put("ohs_periodic_elsewhere", Res.string.ohs_periodic_elsewhere)
  map.put("ohs_periodic_missing", Res.string.ohs_periodic_missing)
  map.put("ohs_periodic_test_passed", Res.string.ohs_periodic_test_passed)
  map.put("ohs_position", Res.string.ohs_position)
  map.put("ohs_record_complete", Res.string.ohs_record_complete)
  map.put("ohs_record_exam", Res.string.ohs_record_exam)
  map.put("ohs_record_general", Res.string.ohs_record_general)
  map.put("ohs_record_incomplete", Res.string.ohs_record_incomplete)
  map.put("ohs_record_station", Res.string.ohs_record_station)
  map.put("ohs_record_title", Res.string.ohs_record_title)
  map.put("ohs_record_title_of", Res.string.ohs_record_title_of)
  map.put("ohs_recorded", Res.string.ohs_recorded)
  map.put("ohs_save", Res.string.ohs_save)
  map.put("ohs_settings", Res.string.ohs_settings)
  map.put("ohs_station", Res.string.ohs_station)
  map.put("ohs_station_missing", Res.string.ohs_station_missing)
  map.put("ohs_station_not_required", Res.string.ohs_station_not_required)
  map.put("ohs_station_required", Res.string.ohs_station_required)
  map.put("ohs_station_required_hint", Res.string.ohs_station_required_hint)
  map.put("ohs_status_done", Res.string.ohs_status_done)
  map.put("ohs_status_missing", Res.string.ohs_status_missing)
  map.put("ohs_status_not_required", Res.string.ohs_status_not_required)
  map.put("ohs_status_to_confirm", Res.string.ohs_status_to_confirm)
  map.put("ohs_to_confirm_general", Res.string.ohs_to_confirm_general)
  map.put("ohs_to_confirm_station", Res.string.ohs_to_confirm_station)
  map.put("ohs_waiting_confirmation", Res.string.ohs_waiting_confirmation)
  map.put("ok", Res.string.ok)
  map.put("onboarding_business_desc", Res.string.onboarding_business_desc)
  map.put("onboarding_business_title", Res.string.onboarding_business_title)
  map.put("onboarding_day_template", Res.string.onboarding_day_template)
  map.put("onboarding_done_generic", Res.string.onboarding_done_generic)
  map.put("onboarding_done_join", Res.string.onboarding_done_join)
  map.put("onboarding_done_owner", Res.string.onboarding_done_owner)
  map.put("onboarding_done_permissions", Res.string.onboarding_done_permissions)
  map.put("onboarding_done_title", Res.string.onboarding_done_title)
  map.put("onboarding_error_empty_code", Res.string.onboarding_error_empty_code)
  map.put("onboarding_finance_desc", Res.string.onboarding_finance_desc)
  map.put("onboarding_finance_no", Res.string.onboarding_finance_no)
  map.put("onboarding_finance_no_desc", Res.string.onboarding_finance_no_desc)
  map.put("onboarding_finance_title", Res.string.onboarding_finance_title)
  map.put("onboarding_finance_yes", Res.string.onboarding_finance_yes)
  map.put("onboarding_finance_yes_desc", Res.string.onboarding_finance_yes_desc)
  map.put("onboarding_finishing", Res.string.onboarding_finishing)
  map.put("onboarding_get_started", Res.string.onboarding_get_started)
  map.put("onboarding_go_to_dashboard", Res.string.onboarding_go_to_dashboard)
  map.put("onboarding_hours_closes", Res.string.onboarding_hours_closes)
  map.put("onboarding_hours_days", Res.string.onboarding_hours_days)
  map.put("onboarding_hours_desc", Res.string.onboarding_hours_desc)
  map.put("onboarding_hours_earlier", Res.string.onboarding_hours_earlier)
}
